import styled from '@emotion/styled'
import { STEP_LAYOUT_SMALL_WIDTH } from '../shared/shared-step-layout.styled'

const ZOOM_IN_ANIMATION = `
  @keyframes zoom-in {
    0% {
      transform: scale(0.5, 0.5);
    }
    100% {
      transform: scale(1, 1);
    }
  }
`

export const FlowOuter = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  overflow: auto;
  background: rgba(0, 0, 0, 0.25);
  padding: 0;
`

export const FlowInner = styled.div`
  ${ZOOM_IN_ANIMATION}
  display: flex;
  height: 100%;
  min-height: 88vh;
  animation: zoom-in 0.25s ease;
  justify-content: center;
  align-items: flex-end;

  @media (min-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    align-items: center;
  }
`
